/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';

export default (visualizationType :any, timeSeriesAttr :any) :boolean => {

    if (!visualizationType.isTimeSeries) {
        // it's not a timeSeries chart, no need to validate it
        return true;
    }

    const { requirements } = visualizationType;
    if (!requirements) {
        // no requirements means no violations
        return true;
    }

    const { fields } = requirements;
    if (!fields) {
        // no fields from requirements means no violations
        return true;
    }

    let
        typePassed = false,
        categorizerPassed = false;

    if (fields.type !== 'time' || timeSeriesAttr.isDateTime) {
        typePassed = true;
    }
    if (!fields.categorizer || _.contains(fields.categorizer, timeSeriesAttr.categorizer)) {
        categorizerPassed = true;
    }

    return typePassed && categorizerPassed;
};
